/*eslint-disable*/ export const messages = {
    "Go to the first page": "Ir para a primeira página",
    "Go to the last page": "Ir para a última página",
    "Pagination, showing {from} through {to} of {total} entities": [
        "Paginação, exibindo de ",
        ["from"],
        " a ",
        ["to"],
        " de ",
        ["total"],
        " entidades",
    ],
    "Show next {entitiesPerPage} entities": ["Exibir as próximas ", ["entitiesPerPage"], " entidades"],
    "Show previous {entitiesPerPage} entities": ["Exibir as ", ["entitiesPerPage"], " entidades anteriores"],
    "{from} through {to} of {total}": [["from"], " a ", ["to"], " de ", ["total"]],
    "{from}-{to} of {total}": [["from"], " - ", ["to"], " de ", ["total"]],
};
